import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

import { Flag, FlagKey } from '@services/flag';

import { RootState } from './store';

export enum FlagType {
  Event = 'event',
  System = 'system',
}

interface State {
  [FlagType.Event]: Record<string, boolean>;
  [FlagType.System]: Record<string, boolean>;
}

export const initialState: State = {
  [FlagType.Event]: {},
  [FlagType.System]: {},
};

const prepare = (flags: Flag[]) => {
  let payload = null;

  if (flags) {
    payload = flags.reduce(
      (prev, { enabled: value, keyId: key }) => ({
        ...prev,
        [key]: value,
      }),
      {}
    );
  }

  return { payload, meta: null, error: null };
};

const featureFlagSlice = createSlice({
  name: 'flag',
  initialState,
  reducers: {
    setEvent: {
      prepare,
      reducer(state, { payload }) {
        // eslint-disable-next-line no-param-reassign
        state[FlagType.Event] = payload;
      },
    },
    setSystem: {
      prepare,
      reducer(state, { payload }) {
        state[FlagType.System] = payload;
      },
    },
  },
});

export default featureFlagSlice;

export const useIsFlagEnabled = (key: FlagKey) =>
  useSelector(
    (state: RootState) =>
      state[featureFlagSlice.name]?.[FlagType.Event]?.[key] ??
      state[featureFlagSlice.name]?.[FlagType.System]?.[key] ??
      false
  );

export const {
  actions: { setSystem, setEvent },
  reducer: flagReducer,
} = featureFlagSlice;
